

import { AlertCircle, RefreshCw } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';

interface ShareErrorProps {
  error: string;
  errorDetails: string | null;
  onRetry: () => void;
}

export function ShareError({ error, errorDetails, onRetry }: ShareErrorProps) {
  return (
    <div className="py-6 space-y-4">
      <Alert variant="destructive">
        <AlertCircle className="h-4 w-4" />
        <AlertTitle>Error sharing game plan</AlertTitle>
        <AlertDescription>
          {error}
          {errorDetails && (
            <details className="mt-2 text-xs">
              <summary className="cursor-pointer">Technical details</summary>
              <p className="mt-1">{errorDetails}</p>
            </details>
          )}
        </AlertDescription>
      </Alert>
      <div className="flex justify-center">
        <Button onClick={onRetry} className="flex items-center gap-2">
          <RefreshCw className="h-4 w-4" />
          Try Again
        </Button>
      </div>
    </div>
  );
}
